<template>
    <div>
        <div class="header" style="margin-bottom: 0.5em;font-size: 1.125em;line-height: 1.5em;">
            {{aoi.label}}
        </div>
        <div style="color: rgb(208, 208, 208)">
            <p style="margin-bottom: 2px">
                {{formatCoords(aoi.center)}}
            </p>
            <p>
                {{formatDate(aoi.start)+" — "+formatDate(aoi.end)}}
            </p>
        </div>
        <div style="padding-right: 15px;margin-top: 5px;display: flex;align-items: center">
            <p style="font-size: 0.85em;margin-left: auto;color: rgb(158, 157, 157)">
                {{formatTime(aoi.creationTime)}}
            </p>
        </div>
        <div style="display: flex" :style="{'align-items':aoi.status==='done'?'center':undefined}">
            <status-chip :status="aoi.status"/>
            <div v-if="aoi.status==='rejected'&&aoi.statusMessage"
                 style="color: rgb(255, 109, 109);margin-left: 5px;margin-top: 5px">
                <p style="padding-left: 5px">
                    {{aoi.statusMessage}}
                </p>
            </div>

            <v-btn v-if="aoi.status==='done'"
                   flat icon color="grey lighten-2"
                   title="Скачать снимок"
                   @click.stop="onDownloadResultButtonClick">
                <v-icon>mdi-download</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    import moment from 'moment'

    moment.locale('ru');

    import {formatCoords} from '@/lib/common-util'

    import StatusChip from '@/components/status-chip/status-chip';

    export default {
        props: {
            aoi: {
                type: Object,
                required: true
            }
        },
        data() {
            return {}
        },
        computed: {},
        methods: {
            formatDate(date) {
                return moment(date).format("DD MMMM YYYY");
            },
            formatTime(time) {
                return moment(time).format("DD.MM.YYYY HH:mm");
            },
            formatCoords(coords) {
                return formatCoords(coords);
            },
            onDownloadResultButtonClick() {
                this.$emit('downloadResultButtonClick', this.aoi.id);
            }
        },

        components: {StatusChip}
    }
</script>

<style scoped>

</style>
